import type { FilesListFile } from '@cartwhl/ui/input/FilesList';

import type { AssetLibraryMediaSelection } from '../../AssetLibrary/assetLibraryMediaSelection';
import BatchReferenceAddMenu from '../../shared/BatchReferenceAddMenu';
import ComicVideoUploadRow from './ComicVideoUploadRow';

export const COMIC_VIDEO_LIST_MAX_HEIGHT_PX = 300;

export interface ComicVideoListPanelProps {
  libraryVideos: AssetLibraryMediaSelection[];
  localFiles: FilesListFile[];
  onRemoveLibraryVideo: (mediaID: string) => void;
  onRemoveLocalFile: (fileId: string) => void;
  onAddFromLibrary: () => void;
  onAddFromComputer: () => void;
  maxHeight?: number;
}

export default function ComicVideoListPanel({
  libraryVideos,
  localFiles,
  onRemoveLibraryVideo,
  onRemoveLocalFile,
  onAddFromLibrary,
  onAddFromComputer,
  maxHeight = COMIC_VIDEO_LIST_MAX_HEIGHT_PX,
}: ComicVideoListPanelProps) {
  return (
    <div
      className="bg-secondary border-primary flex flex-col overflow-hidden rounded-lg border"
      style={{ maxHeight }}
      onClick={(event) => event.stopPropagation()}
    >
      <div className="divide-gray-30 dark:divide-gray-60 styled-scrollbar min-h-0 flex-1 divide-y overflow-y-auto">
        {libraryVideos.map((video, index) => (
          <ComicVideoUploadRow
            key={video.mediaID}
            index={index}
            label={video.label}
            thumbnailUrl={video.thumbnailURL ?? ''}
            onRemove={() => onRemoveLibraryVideo(video.mediaID)}
          />
        ))}

        {localFiles.map((file, index) => (
          <ComicVideoUploadRow
            key={file.id}
            index={libraryVideos.length + index}
            label={file.file.name}
            thumbnailUrl={file.objectUrl}
            onRemove={() => onRemoveLocalFile(file.id)}
          />
        ))}
      </div>

      <div className="border-primary bg-secondary sticky bottom-0 shrink-0 border-t">
        <BatchReferenceAddMenu
          onAddFromLibrary={onAddFromLibrary}
          onAddFromComputer={onAddFromComputer}
        />
      </div>
    </div>
  );
}
